/**
 * What a confirmed "project from email" card says once it is done. Web and
 * native both show it, so the wording lives here once. The server's result is
 * read defensively: an older server sends none of these fields.
 */
export function projectFromEmailNotice(result: unknown): string | null {
  const value = result && typeof result === 'object' ? result as Record<string, unknown> : {};
  const left = Array.isArray(value.attachmentsLeftInMailbox)
    ? value.attachmentsLeftInMailbox.filter((name): name is string => typeof name === 'string')
    : [];
  const notes: string[] = [];
  if (value.emailFiled === false) notes.push('The email could not be filed to the project. File it from Email.');
  if (left.length) {
    const shown = left.slice(0, 5).join(', ');
    notes.push(`Left in your mailbox: ${shown}${left.length > 5 ? ` and ${left.length - 5} more` : ''}. Save them to the project's Documents if you need them there.`);
  }
  return notes.length ? notes.join(' ') : null;
}
